import React from 'react';
import './A2.css';

const A2: React.FC = () => {
  const cards = [
    { title: 'Basic', subtitle: 'Build on basics', badge: 'A2', bg: '#5EEAD4' },
    { title: 'Conversations', subtitle: 'Dialogue practice', badge: 'A2', bg: '#3B82F6' },
    { title: 'Grammar', subtitle: 'Deepen grammar', badge: 'A2', bg: '#EF4444' },
    { title: 'Stories', subtitle: 'Understand stories', badge: 'A2', bg: '#9333EA' },
  ];

  return (
    <div className="level-wrapper">
      <h1 className="level-title">A2 - Elementary Level</h1>
      <div className="level-grid">
        {cards.map((card, index) => (
          <div key={index} className="level-card" style={{ backgroundColor: card.bg }}>
            <div className="level-badge">{card.badge}</div>
            <div className="level-content">
              <h2>{card.title}</h2>
              <p>{card.subtitle}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default A2;
